import { getShopFromLocalStorage } from "@/hooks/use-shop";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  component: App,
  beforeLoad: ({ search }) => {
    if (search.kioskKey || getShopFromLocalStorage()) {
      return redirect({
        to: "/start-screen",
        reloadDocument: true,
        search: (prev) => prev,
      });
    }
    console.log("beforeLoad");
  },
});

function App() {
  return null;
}
